import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import type { EsnToastTone } from '../../../shared/types/molecules';
import { ButtonComponent } from '../../atoms/button/button.component';
import { IconComponent } from '../../atoms/icon/icon.component';

/**
 * Short confirmation of something the user just did, optionally with an undo for actions too
 * small for a dialog but too destructive to leave without a way back. Escape dismisses it.
 */
@Component({
  selector: 'esn-toast',
  imports: [ButtonComponent, IconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'status', 'aria-live': 'polite', '(keydown.escape)': 'dismissed.emit()' },
})
export class ToastComponent {
  readonly message = input.required<string>();

  /**
   * Label of the inline action (Figma "Action=Undo"); `null` renders the plain notice.
   */
  readonly actionLabel = input<string | null>(null);

  /**
   * `danger` reports a failure: danger hairline and glyph.
   */
  readonly tone = input<EsnToastTone>('neutral');

  readonly action = output<void>();
  readonly dismissed = output<void>();
}
